import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {Component} from "react";
import * as React from "react";
import {Field} from "redux-form";
import {Button, Col, Label, Row} from "reactstrap";
import Dropzone from "react-dropzone";
import {toastr} from "react-redux-toastr";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Jednoduchý field pro upload souboru.
 * Zobrazuje tlačítko pro výběr souboru, po jeho výběru pak jeho název.
 * Umožňuje vybrat jen jeden soubor.
 */
class SimpleFileUploadField extends Component<WithTranslation> {

    static propTypes = {
        label: PropTypes.string,
        accept: PropTypes.string, // volitelný filtr na typy souborů které budou akceptovány, jinak bude zobrazena chybová hláška, může se jednat o mime typy nebo přípony, např. ".jpg, .png" nebo "image/jpeg, image/png"
    };

    static defaultProps = {
        disabled: false,
        accept: null,
    };

    handleFilesDropped = (field, accepted, rejected) => {
        const {accept, t} = this.props;
        if (rejected && rejected.length > 0) {
            toastr.error(t('validation.file_must_be_of_type', {type: accept}));
        } else if (Array.isArray(accepted) && accepted.length > 0) {
            field.input.onChange(accepted[0]);
        }
    };

    renderField = (field) => {
        const {label, disabled, accept, t} = this.props;
        const file = field.input.value;
        const dropzone = <div>
            <Dropzone disabled={disabled} accept={accept} onDrop={this.handleFilesDropped.bind(this, field)} style={{}}>
                {!file ? <Button type="button" color="primary">{t('choose_file')}</Button> : <span>{file.name}</span>}
            </Dropzone>
            {field.meta.touched && field.meta.error ? <span style={{display: "block", color: "#a94442"}}>{field.meta.error}</span> : null}
        </div>;
        if (label) {
            return <Row className="form-group">
                <Label xs={12} sm={4} className="col-form-label">{label}</Label>
                <Col xs={12} sm={8} style={{display: "flex", alignItems: "center"}}>{dropzone}</Col>
            </Row>
        } else {
            return dropzone;
        }
    };

    render() {
        const {label, disabled, ...other} = this.props;
        return <Field {...other} component={this.renderField}/>
    }
}

export default connect()(withTranslation()(SimpleFileUploadField));
